import type { Node2d } from "@logic/lib/mesh"

import type { TransactionOperation } from "."
import { findNodeState, nodeIndex } from "../nodes"
import type { NodeActionTo_, NodeChangeTo_ } from "../timeline"
import { generateElementChange } from "../timeline/transactions"

export const addNode: TransactionOperation<
  { id: string; payload: Node2d },
  NodeChangeTo_[`CREATE`]
> = (transactors, { id, payload }) => {
  console.debug(`addNode`, id, JSON.stringify(payload))
  const { set } = transactors
  set(findNodeState(id), payload)
  set(nodeIndex, (s) => [...s, id])
  const action: NodeActionTo_[`CREATE`] = {
    type: `CREATE`,
    family: `NODE`,
    id,
  }
  const change = generateElementChange(transactors, { action })

  return change as NodeChangeTo_[`CREATE`]
}
